/* 
On loading single receipt info for Add Information
params receiptId : id of the reciept
*/
export const loadReceipt = (receiptId) => {
    return dispatch => {
      dispatch({
        type: 'LOAD_RECEIPT',
        receiptId
      })
    }
}


/* 
On loading single receipt info for Add Information Success Action
params receipt : reciept data
*/
export const loadReceiptSuccess = (receiptData) => {
    return dispatch => {
      dispatch({
        type: 'LOAD_RECEIPT_SUCCESS',
        receiptData
      })
    }
}


/* 
On adding processing fail action
params receipt : reciept data
*/
export const loadReceiptFail = (receiptId, errors) => {
    return dispatch => {
      dispatch({
        type: 'LOAD_RECEIPT_FAIL',
        receiptId,
        errors
      })
    }
}
